import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from '../../../../i18n/use-translation';
import { toast } from 'react-toastify';
import { getCurrentUserSelector } from '../../../../store/auth/selector';
import { isLoadingSelector } from '../../../../store/app/selector';
import { setModalAction } from '../../../../store/modal/factory';
import { ActiveModal } from '../../../enums/active-modal';
import { sendFeedback } from '../../../../api/feedback';
import { FeedbackParams } from '../feedback-params';
import { FormikHelpers } from 'formik';

export function useViewModel() {
  const { t, locale } = useTranslation();
  const dispatch = useDispatch();
  const user = useSelector(getCurrentUserSelector);
  const isLoading = useSelector(isLoadingSelector);

  const formSubmitHandler = async (data: FeedbackParams, formik: FormikHelpers<FeedbackParams>) => {
    try {
      await sendFeedback(data, locale);
      toast.success(t('feedback_success'), {
        position: 'top-right',
        autoClose: 800,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
      });
      dispatch(setModalAction(ActiveModal.NONE));
    } catch (e) {
      // @ts-ignore
      toast.error(e.message, {
        position: 'top-right',
        autoClose: 800,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
      });
    }
  };

  return {
    formSubmitHandler,
    user,
    isLoading,
  };
}
